
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    title: String
  },
  methods:{
    click(e){
      this.$emit('click', e)
    }
  }
}
